import styled from 'theme';

export const Attachment = styled.a`
  font-weight: var(--sys-font-weight-bold);
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  svg {
    position: relative;
  }
`;
